import React from 'react';
import {
    MsalAuthenticationTemplate,
} from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { redirectRequest } from './msal';
import { Loading } from 'pages/Loading';
import { Error } from 'pages/Error';

function LoadingComponent() {
    return <Loading />;
}

function ErrorComponent(instance: any) {
    return <Error error={instance.error} />;
}

type Props = {
    children?: React.ReactNode;
};

export const AuthProvider: React.FC<Props> = ({ children }) => {
    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={redirectRequest}
            errorComponent={ErrorComponent}
            loadingComponent={LoadingComponent}>
            {children}
        </MsalAuthenticationTemplate>
    );
};
